import ScreenLoaderView from "./ScreenLoaderView";

function ScreenLoader({ groups }) {
  return <ScreenLoaderView groups={groups} />;
}

export default ScreenLoader;
